module.exports = __webpack_public_path__ + "img/mobile-21.793e4158.png";